<template>
  <div class="vue-login-wrap">
    <div>
      <b-modal
      id="force-new-password-modal"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      :modal-class="myclass">
        <template v-slot:modal-header>
          <h3>Change Password</h3>
          <div class="status-messages login">
            <span
            v-if="loginError"
            class="status-message error">{{loginError}}</span>
          </div>
        </template>
        <div class="form-container">
          <div class="instructions">You are required to change your password. Please complete the below form and then click "Submit".</div>
          <form>
            <div class="form-control-container">
              <label>New password</label>
              <input v-model="credentials.newPassword" type="password" v-on:keyup="validatePassword()" @keyup.enter="changePassword">
              <div v-if="credentials.newPassword && !newPasswordValid" class="validation-message error">{{passwordValidationInstructions}}</div>
            </div>
            <div class="form-control-container">
              <label>Confirm new password</label>
              <input v-model="credentials.newPasswordConfirm" type="password" @keyup.enter="changePassword">
              <div v-if="credentials.newPasswordConfirm && credentials.newPasswordConfirm.length >= credentials.newPassword.length && credentials.newPassword !== credentials.newPasswordConfirm" class="validation-message error">Passwords must match</div>
            </div>
            <div class="buttons">
              <b-spinner v-if="changingPassword" class="spinner"></b-spinner>
              <div v-if="!changingPassword">
                <b-button
                class="submit"
                v-on:click="changePassword()"
                v-bind:disabled="!this.newPasswordValid || !credentials.newPassword  || !credentials.newPasswordConfirm || credentials.newPassword !== credentials.newPasswordConfirm">Submit</b-button>
              </div>
            </div>
          </form>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Authentication from "@/services/authentication";
import vueMqMixin from "../mixins/VueMqMixin";
import AppConfig from "../../../resources/AppConfig.js";

export default {
  name: 'ForceNewPasswordModal',
  mixins: [vueMqMixin],
  props: {
    user: Object,
    forceNewPasswordSuccess: Function,
    loginSuccess: Function,
  },
  data() {
    return {
      signingIn: undefined,
      changingPassword: undefined,
      credentials: {},
      myclass: [],
      loginError: false,
      newPasswordValid: false,
      passwordValidationRegex: AppConfig.passwordValidationRegex,
      passwordValidationInstructions: AppConfig.passwordValidationInstructions
    }
  },
  async created() {
    Vue.nextTick(() => this.$bvModal.show('force-new-password-modal'));
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal force-new-password isMobileOrTablet'] : ['vt-outages-modal force-new-password'];
  },
  methods: {
      async changePassword() {
        this.loginError = undefined;

        if (!this.newPasswordValid || !this.credentials.newPassword  || !this.credentials.newPasswordConfirm || this.credentials.newPassword !== this.credentials.newPasswordConfirm) {
          this.loginError = 'Please enter your new password and confirm new password.';
          return;
        }

        this.changingPassword =  true;
        try {
            await Authentication.completeNewPassword(this.user, this.credentials.newPassword);
            this.forceNewPasswordSuccess();
        } catch (error) {
          this.loginError = error && error.message ? error.message : 'There was an error chaning your password';
          this.changingPassword = undefined;
        }
      },
      validatePassword() {
        this.newPasswordValid = this.passwordValidationRegex.test(this.credentials.newPassword);

        if (this.newPasswordValid && this.credentials.newPassword  && this.credentials.newPasswordConfirm) {
          this.loginError = '';
        }
      }
  }
}
</script>
<style lang="scss" scoped>
#force-new-password-modal{
  .instructions{
    margin: 0 0 20px 0;
    padding: 0;
    text-align: left;
  }

  form{
    .form-control-container{
      .validation-message{
        margin: 20px 0;

        &.error {
          color: #800000;
        }
      }

      .buttons{
        .spinner{
          height: 40px;
          width: 40px;
          font-size: 22px;
          color: #fbd850;
        }

      }
    }
  }
}
</style>
